import React, { useEffect, useRef } from "react";
import { FiShoppingBag, FiMusic, FiUsers, FiHeart } from "react-icons/fi";
import "./experience.css";

const items = [
  {
    icon: <FiShoppingBag />,
    title: "Curated Vendors",
    body: "Every stall at a Biz Baz event is carefully handpicked. From independent makers and original artists to established local brands and names from beyond Kenya, we curate a mix worth discovering — hand-stitched fashion, homeware and décor, jewellery and accessories, skincare and wellness, art and craft, plants and garden, kids and lifestyle, and food and drink that tells a story. The common thread isn't size or origin. It's quality, and people who care about what they bring.",
  },
  {
    icon: <FiMusic />,
    title: "Live Experiences",
    body: "A Biz Baz market moves to its own rhythm. Live music, DJs, and performances roll through the day, brand activations from vendors and partners give you something to jump into, and there's always a kids' corner keeping the little ones busy. Come to shop, come to discover, or come just to hang out — there's always something happening, and always a reason to stay a little longer.",
  },
  {
    icon: <FiUsers />,
    title: "Family Friendly & Accessible",
    body: "Open-air, safe, and built for everyone — something for the little ones, and room to breathe. We set up across large open grounds, with most of the space fully accessible and our team on hand to help anyone who needs it. Leashed dogs welcome. Inclusive and open to all, there's a source of enjoyment here for everyone.",
  },
  {
    icon: <FiHeart />,
    title: "Community First",
    body: "Biz Baz has grown into something bigger than events — a year-round ecosystem for the makers, creators, and small businesses driving Kenya's creative economy. What began as a marketplace is now a platform, and our commitment to inclusivity has built a large, growing community of creators within the creative economy. The Biz Baz Vendor Community is open to anyone creating within the categories we champion — makers, artists, designers, food creators, and businesses building something of their own. Every edition is an investment in creatives and in the belief that when we shop local, everyone wins.",
  },
];

const Experience = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = itemRefs.current.map((el, i) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.style.transitionDelay = `${i * 0.12}s`;
            el.classList.add("exp-item-visible");
            obs.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((obs) => obs && obs.disconnect());
  }, []);

  return (
    <section className="experience-section">

      {/* HEADER */}
      <div className="experience-header">
        <span className="experience-tag">What To Expect</span>
        <h2 className="experience-heading">The Experience</h2>
      </div>

      {/* TWO-COLUMN ITEMS */}
      <div className="experience-grid">
        {items.map((item, i) => (
          <div
            key={item.title}
            className="exp-item"
            ref={(el) => (itemRefs.current[i] = el)}
          >
            <div className="exp-icon-col">
              <div className="exp-icon">{item.icon}</div>
              <div className="exp-icon-line" />
            </div>
            <div className="exp-text-col">
              <h3 className="exp-title">{item.title}</h3>
              <p className="exp-body">{item.body}</p>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default Experience;